require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-the-best-of-d-ad-festival-2018.json") })
        }
      }, "path---authors-the-best-of-d-ad-festival-2018");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-the-best-of-d-ad-festival-2018!./.cache/json/authors-the-best-of-d-ad-festival-2018.json
// module id = 1345
// module chunks = 231608221292675